<template>
  <!-- Not a manage action: a view-only colleague opens it too, to copy a teammate's link -->
  <Button v-bind="$attrs" variant="outline" :size="size" :loading="isOpening" @click="open">
    <Icon name="link-01" size="small" />
    <span>Get apply link</span>
  </Button>

  <ApplyLinkModal ref="modalRef" :property-id="propertyId" :address="address" :is-rented-out="isRentedOut" />
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button, Icon } from '@tallo/design-system';

import ApplyLinkModal from './apply-link-modal.vue';

defineOptions({ inheritAttrs: false });

withDefaults(defineProps<{ propertyId: string; address: string; isRentedOut?: boolean; size?: 'medium' | 'large' }>(), {
  isRentedOut: false,
  size: 'medium',
});

const modalRef = ref<InstanceType<typeof ApplyLinkModal>>();
const isOpening = ref(false);

/** Loads what the modal shows first (the button spins meanwhile), then opens it. */
async function open(): Promise<void> {
  isOpening.value = true;

  try {
    await modalRef.value?.open();
  } finally {
    isOpening.value = false;
  }
}

defineExpose({ open });
</script>
